// 不需要登录就能访问的路由

export default [{
    path: '/login',
    component: ()=> import("@/views/Login"),
    meta:{
        title:"登录"
    },
    children:[]
},
{
    path: '/reg',
    component: ()=> import("@/views/Reg"),
    meta:{
        title:"注册"
    },
    children:[]
},
{
    path: '/login-set-pwd',
    component: ()=> import("@/views/LoginSetPwd"),
    meta:{
        title:"修改密码"
    },
    children:[]
}]